import { spinnerOverlayDefaultStyle } from './interstitialOverlayDefaultStyle';
export const spinnerOverlayStyleBuilder = (theme, fullScreen) => {
  const style = spinnerOverlayDefaultStyle(theme, fullScreen);
  return style;
};